var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "columns is-centered" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c(
          "form",
          { ref: "form" },
          [
            _c(
              "b-field",
              { attrs: { label: "デバイスID" } },
              [
                _c("b-input", {
                  attrs: {
                    type: "text",
                    value: "device_id",
                    maxlength: "256",
                    required: ""
                  },
                  model: {
                    value: _vm.deviceId,
                    callback: function($$v) {
                      _vm.deviceId = $$v
                    },
                    expression: "deviceId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                attrs: { size: "is-large", disabled: _vm.isDisabled },
                on: { click: _vm.saveData }
              },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ed67278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ed67278","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kitting.vue
// module id = d1hs
// module chunks = 0